import React from 'react'

function Footer() {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem' }}>
          <a
            href="/register"
            style={{ color: '#3182ce', textDecoration: 'underline', fontWeight: 500, cursor: 'pointer' }}
          >
            Register as an academy
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer